import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { developerAwardsSelector } from 'shared/selectors/specialPromosBlocks/developerAwardsSelector';

import { Awards } from './Awards';
import { trackShowAwardsBlock } from './internal/tracking/trackShowAwardsBlock';

export const AwardsContainer: FC = () => {
  const awards = useSelector(developerAwardsSelector);

  if (!awards?.sources?.length) {
    return null;
  }

  return (
    <Awards
      awards={awards.awards}
      awardsLabel={awards.text}
      awardsSources={awards.sources}
      onView={() => trackShowAwardsBlock(awards)}
    />
  );
};
